var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 20C16.0228 20 20.5 15.5228 20.5 10C20.5 4.47715 16.0228 0 10.5 0C4.97715 0 0.5 4.47715 0.5 10C0.5 15.5228 4.97715 20 10.5 20Z",
    fill: "#1F55A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16535 13.1868L6.44726 10.485C6.37131 10.4091 6.33333 10.3114 6.33333 10.192C6.33333 10.0727 6.37131 9.97504 6.44726 9.89908L7.04947 9.31315C7.12543 9.22634 7.22037 9.18294 7.3343 9.18294C7.44823 9.18294 7.5486 9.22634 7.63541 9.31315L9.45832 11.1361L13.3646 7.22982C13.4514 7.14301 13.5517 7.09961 13.6657 7.09961C13.7796 7.09961 13.8745 7.14301 13.9505 7.22982L14.5527 7.81575C14.6287 7.89171 14.6666 7.98936 14.6666 8.10872C14.6666 8.22808 14.6287 8.32573 14.5527 8.40169L9.75129 13.1868C9.67533 13.2736 9.57768 13.317 9.45832 13.317C9.33896 13.317 9.24131 13.2736 9.16535 13.1868Z",
    fill: "#1F55A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yes-icon.09db885b35b35586daae494d45a38a14.svg";
export { ForwardRef as ReactComponent };